module.exports = __webpack_public_path__ + "static/media/room.114c84b6.svg";